"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const DataSource_1 = __importDefault(require("./DataSource"));
const CollectionCacheable_1 = __importDefault(require("../../services/objects/CollectionCacheable"));
const CollectionLoadable_1 = __importDefault(require("../../services/objects/CollectionLoadable"));
const GenericObjectCollection_1 = __importDefault(require("../../utils/objects/GenericObjectCollection"));
/**
 * A collection of data sources
 */
class DataSourceCollection extends GenericObjectCollection_1.default {
    constructor(features, attributes, eventManager) {
        super(features, attributes, false, true);
        this._eventManager = eventManager;
    }
    progress(progressEventName, completeRatio) {
        if (this._eventManager)
            this._eventManager.emitProgress(`${DataSourceCollection.displayName}${progressEventName}`, completeRatio);
    }
    newObject(attribs, isNew = false, collectionManager) {
        return new DataSource_1.default(attribs, isNew, collectionManager);
    }
    saveCache(socket) {
        return CollectionCacheable_1.default.saveCache(this, socket);
    }
    loadCache(socket) {
        return CollectionCacheable_1.default.loadCache(this, socket);
    }
    loadFromServer(socket, collectionManager) {
        return CollectionLoadable_1.default.loadFromServer(this, socket, collectionManager);
    }
    loadFromCollection(collection, collectionManager) {
        return CollectionLoadable_1.default.loadFromCollection(this, collection, collectionManager);
    }
}
DataSourceCollection.displayName = 'DataSourceCollection';
DataSourceCollection.socketPrefix = 'dataSources';
DataSourceCollection.instanceClass = DataSource_1.default;
exports.default = DataSourceCollection;
//# sourceMappingURL=DataSourceCollection.js.map